module.exports = __webpack_public_path__ + "media/application/images/2018/facebook-green-d55bdfcf1af426ec6a1abc0451c4234a.svg";